import BaseService from '../baseServices';
import REST from '../../configs/rest';

function getItemReports(params) {
  let q = '';
  if (params?.start_date && params?.end_date) {
    q = `?start_date=${params?.start_date}&end_date=${params?.end_date}`;
  }
  return BaseService.get(`${REST.REPORT_ITEM}${q}`);
}

function getVendorsReports(params) {
  let q = '';
  if (params?.start_date && params?.end_date) {
    q = `?start_date=${params?.start_date}&end_date=${params?.end_date}`;
  }
  return BaseService.get(`${REST.REPORT_VENDOR}${q}`);
}

export default {
  getItemReports,
  getVendorsReports,
};
